import React from 'react';
import { Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import './InfoTooltip.css';

interface InfoTooltipProps {
  text: string;
  placement?: 'top' | 'bottom' | 'left' | 'right' | 'top-start' | 'top-end' | 'bottom-start' | 'bottom-end';
}

/**
 * InfoTooltip Component
 * Displays an info icon with a tooltip on hover.
 * Shared help-tooltip used for metric and table-column context.
 */
const InfoTooltip: React.FC<InfoTooltipProps> = ({ text, placement = 'top' }) => {
  return (
    <Tooltip
      title={text}
      placement={placement}
      arrow
      enterDelay={200}
      leaveDelay={0}
    >
      <InfoOutlinedIcon className="info-tooltip-icon" />
    </Tooltip>
  );
};

export default InfoTooltip;
